import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Grid } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import React from 'react';
import { ExposureConfigurationResponse } from '../../../api/ConfigApi';
import { AuthData } from '../../../context/auth';
import { PolicyData, withPolicyContext } from '../../../context/policy';
import { CurrencyCode } from '../../../types/currencyCode';
import {
	ExposureCreateRequest,
	FieldGroupCreateRequest,
	FieldValuesMap,
	PerilCreateRequest,
	PolicyCharacteristics,
} from '../../../types/policy';
import AddedPerils from './AddedPerils';
import ReviewChangesField from './ReviewChangesField';

interface Props {
	authData: AuthData;
	policyData: PolicyData;
	policyCharacteristic: PolicyCharacteristics;
	addedExposures: ExposureCreateRequest[];
	exposureConfigurations: ExposureConfigurationResponse[];
	currency: CurrencyCode;
}

const AddedExposureDetails = (props: Props) => {
	const {
		policyCharacteristic,
		addedExposures,
		exposureConfigurations,
		currency,
		authData,
	} = props;

	if (!addedExposures.length) {
		return null;
	}

	const renderFields = (
		exposureName: string,
		fieldValues: FieldValuesMap,
		fieldGroups: FieldGroupCreateRequest[],
	) => {
		const exposureConfig = exposureConfigurations.find(
			(config) => config.name === exposureName,
		);
		const fieldConfigs = exposureConfig.fields;
		return fieldConfigs.map((field, ind) => {
			const value = fieldValues[field.name] || '--';
			return (
				<Grid item key={`${field}-${ind}`}>
					<ReviewChangesField
						field={field}
						value={value}
						fieldGroupsByLocator={null}
						allValues={fieldValues}
						currentFieldValues={fieldValues}
						addFieldGroups={fieldGroups}
					/>
				</Grid>
			);
		});
	};

	const renderAddedPerils = (
		addedPerils: PerilCreateRequest[],
		exposureName: string,
	) => {
		const exposureConfig = exposureConfigurations.find(
			(config) => config.name === exposureName,
		);
		return (
			<AddedPerils
				addedPerils={addedPerils}
				exposureConfiguration={exposureConfig}
				policyCharacteristic={policyCharacteristic}
				currency={currency}
				authData={authData}
			/>
		);
	};

	return addedExposures.map((e, ind) => {
		const exposureConfig: ExposureConfigurationResponse =
			exposureConfigurations.find((config) => config.name === e.exposureName);
		const exposureName = exposureConfig.displayName
			? exposureConfig.displayName
			: e.exposureName;
		// TransitionProps={{ unmountOnExit: true }} disables content of Accordion to be mounted
		// even if it's not expanded
		return (
			<Accordion
				key={`addedExposure-${ind}`}
				TransitionProps={{ unmountOnExit: true }}
			>
				<AccordionSummary
					style={{ borderBottom: '1px solid rgba(0, 0, 0, .125)' }}
					expandIcon={<ExpandMoreIcon />}
				>{`Added: ${exposureName}`}</AccordionSummary>
				<AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>
					<Grid container spacing={1}>
						{renderFields(e.exposureName, e.fieldValues, e.fieldGroups)}
					</Grid>
					{renderAddedPerils(e.perils, e.exposureName)}
				</AccordionDetails>
			</Accordion>
		);
	});
};

export default withPolicyContext<Props>(AddedExposureDetails);
